import { checkerboardCombination } from '@/components/CustomCheckerboard/MainViews/SizeSelector/combinations';
import { warps } from '@/components/CustomCheckerboard/MainViews/WarpSelector/warpSettings';
import ugc from "@/mixins/UGC";

const cloneDeep = require('lodash/cloneDeep');

export default {
  mixins: [ ugc ],
  computed: {
    selectedSwatches() {
      return this.$store.state.swatches.selectedSwatches;
    },
  },
  methods: {
    applyCheckerboardTo3D(component) {
      const { ugc } = this.$store.state.customCheckerboard.components[component];

      return new Promise((resolve) => {
        this.applyUGCAsSwatch({ component, ugc })
          .then(() => {
            this.resetGeometrybyUGCFeature();
            this.$store.dispatch("buyPanel/GET_PRICE", { recipe: this.$store.state.recipe.recipe_v2 });
            // updates tabs
            this.$eventBus.$emit("block-features-by-swatch-id");
            this.$store.dispatch("swatches/GET_RELATION_SWATCH_BY_FEATURE_ID", "checkerboard").then(response => {
              this.$store.commit("swatches/SET_DISABLED_SWATCHES_BY_FEATURE", {swatches: response.swatches_not_allowed, feature: "customCheckerboard"});
            });
            resolve({ component, ugc });
          });
      });
    },
    updateCheckerboardRecipe(component) {
      const {
        ugc,
        canvasConfig: { warp, size },
      } = this.$store.state.customCheckerboard.components[component];

      this.$recipe.addToolkitOptions(
        component,
        warps[warp].id,
        checkerboardCombination[size][warp].swatchId,
      );
      this.$recipe.updateUGC(component, ugc, 'custom-checkerboard');
    },
    updateStandardMenuForCustomCheckerboard() {
      const menu = cloneDeep(this.$store.state.standardNavigation.menu);

      for (const component in this.$store.state.customCheckerboard.components) {

        const currentNode = menu.find(node => node.id === component);

        if (currentNode) {
          currentNode.isChecked = !this.selectedSwatches[component]?.default;
        }
      }

      this.$store.commit('standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION', { menu });
    },
  },
};
